import React from 'react'

import LoginActions from '../../actions/LoginActions.js'

import {Colors, IconButton, Popup} from '../../../src/components/UI/index.js'
import LoginPopup from '../../../src/components/login/LoginPopup.js'
import {openMfaPopup} from '../../../src/components/login/mfaPopup.js'
import showTwoFactorWarning from '../../../src/components/login/twoFactorWarning.js'
import TopBarMenu from './TopBarMenu.js'
import TopBarButton from './TopBarButton.js'
import utils from '../../utils/utils.js'

class TopBar extends React.Component {
    onNavigate(link) {
        const {history} = this.props
        history.push(link)
    }

    onClickSwitchAccount() {
        const {user, reseller} = this.props

        const filteredAccounts = user.accounts.filter((account) => account.isMessenger)

        this.loginPopup.open(filteredAccounts, user, (index) => {
            const account = filteredAccounts[index]

            if (account.mfaRequired && !user.is2FASignedIn) {
                if (account.mfaEnabled) {
                    if (account.mfaMethod === 'email') {
                        LoginActions.mailMFACode(null, index, null, (err) => {
                            if (err) {
                                this.popup.setError(err)
                            }
                        })
                    }
                    openMfaPopup(this.popup, {
                        mfaMethod: account.mfaMethod,
                        onLogin: (code) => {
                            LoginActions.switchAccount(index, code, (err) => {
                                if (err) {
                                    this.popup.setError(err)
                                }
                            })
                        }
                    })
                } else {
                    showTwoFactorWarning(this.popup, () => LoginActions.logout())
                }
            } else {
                LoginActions.switchAccount(index, null, (err) => {
                    if (err) {
                        this.setState({loading: false, error: err})

                        if (reseller.settings.mfaAppEnabled) {
                            showTwoFactorWarning(this.popup, () => LoginActions.logout())
                        }
                    }
                })
            }
        })
    }

    render() {
        const {reseller, user, history, showLogo, showBack, onClickBack, showAccount, branding} = this.props

        const style = {
            position: 'fixed',
            top: 0,
            zIndex: 4,
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            height: 50,
            background: Colors.backgroundWhite,
            boxShadow: '0 0 10px 0 rgba(0,0,0,0.1)'
        }

        return (
            <div style={style}>
                {showLogo && branding !== undefined &&
                    <img
                        style={{height: 32, marginLeft: 10}}
                        src={branding?.squareLogo || '/images/VELOYDLOGOSMALL.png'}
                        alt='Logo'
                    />
                }

                {showBack &&
                    <TopBarButton
                        style={{marginLeft: 10, marginRight: 10}}
                        label='Terug'
                        icon='mdi mdi-arrow-left'
                        onClick={onClickBack || (() => history.goBack())}
                    />
                }

                <div style={{flex: 1}} />

                {showAccount &&
                    <>

                        <IconButton icon='mdi mdi-help-circle' onClick={() => utils.onClickHelp(undefined, branding)} />

                        <IconButton icon='mdi mdi-cog' onClick={() => history.push('/koerier/instellingen')} />

                        <TopBarMenu
                            reseller={reseller}
                            user={user}
                            history={history}
                            icon='mdi mdi-account-circle'
                            links={[
                                user?.accounts?.length > 1 && {title: 'Wissel account', icon: 'mdi mdi-account-multiple', onClick: this.onClickSwitchAccount.bind(this)},
                                {title: 'Uitloggen', icon: 'mdi mdi-logout', onClick: () => LoginActions.logout()}
                            ]}
                        />
                    </>
                }

                <LoginPopup ref={(ref) => this.loginPopup = ref} />
                <Popup ref={(ref) => this.popup = ref} />
            </div>

        )
    }
}

export default TopBar
